import axios from "axios";
import {formatAppSnsType, log, removeAllStorage} from "../../utils/helpers";
import * as action from './../../pages/Account/redux/actions';

import {resetState} from "./../../pages/Account/redux/actions";


// log('initAPI', 'saga');
const UNAUTHORIZED = 401;



export const ROUTES = {
    API_LOGIN: '/app/auth/login',
    API_LOGOUT: '/app/auth/logout',
    API_UPLOAD: 'inquiry_create',
    API_REGISTER_USER : '/app/auth/register',
    API_CHECK_VALIDATE_USER : '/app/auth/validate',
    API_FIND_EMAIL : '/app/auth/find-id',
    API_FIND_PASSWORD : '/app/auth/find-password',
    API_GET_BANNER: '/app/banner',
    API_ALBUM: '/app/album',
    API_CHARACTER_FAVORITE: '/app/characters/favorite',
    API_VIDEO: '/app/video',
    API_POINT: '/app/point/balance',
    API_POINT_HISTORY: '/app/point/history',
    API_CURRENT_AWARD: '/app/award/current',
    API_AWARD_ENTRY: '/app/award/entry',
    API_AWARD_VOTE: '/app/award/vote',
    API_AWARD_CHECK_VOTED: '/app/award/check-voted',
    API_AWARD: '/app/award',
    DELETE_AWARD_ENTRY: '/app/award/entry/delete',
    API_CURRENT_AWARD_ENTRY: '/app/award/my-entry',
    API_REGISTER_AWARD_ENTRY: '/app/award/entry',
    API_COUPON: '/app/coupon/my-video-coupon',
    API_CUSTOM_INFORMATION : '/app/custom-information',
    API_CHARACTER: '/app/characters',
    API_VIDEO_DETAIL: '/app/video/detail',
    API_SEND_CODE_PHONE_NUMBER : '/app/code/send',
    API_VERIFY_CODE_PHONE_NUMBER : '/app/code/verify',
    API_UPDATE_AUTH_ME : '/app/auth/me',
    API_VIDEO_DETAIL_TEMPLATE: '/app/video-message/content-template',
    API_PAYMENT: 'app/video-message/create',
    API_NOTIFICATION: '/app/notifications',
    API_VIDEO_UPDATE: '/app/video/update',
    API_VIDEO_EMOJI: '/app/video/emoji',
    API_NOTIFICATION_SETTING : '/app/setting',
    API_AUTH_SNS_LOGIN : '/app/auth/sns/login',
    API_QNA_CATEGORIES: '/app/qna/categories',
    API_QNA_CREATE: '/app/qna/create',
    API_QNA_DETAIL: '/app/qna/:id',
    API_QNA_DELETE: '/app/qna/delete',
    API_GET_AUTH_ME :  '/app/auth/me',
    API_QNA: '/app/qna',
    API_VIDEO_DELETE: '/app/video/delete',
    API_DELETE_ALBUM: '/app/album/delete',
    API_FAQ: '/app/faq',
    API_INFORMATION_SERVICE: '/app/information',
    API_DELETE_USER : '/app/auth/delete-user',
    // API_CHANGE_POINT_TO_COUPON : '/app/point/exchange',
    API_CHANGE_POINT_TO_COUPON : '/app/coupon/exchange',
    API_PAYMENT_REQUEST: '/app/purchase/request',
    API_PURCHASE_VERIFY: '/app/purchase/verify',
    API_RESTRICTED_KEYWORD: 'app/restricted-keyword',
    API_VIDEO_RENDERING_STATUS: 'app/video/get-time-video-rendering',
    API_SHARE_KAKAO: '/app/share-kakao',

};

const API = axios.create({
    baseURL: process.env.REACT_APP_API_URL
});

const _app_token = localStorage.getItem('_APP_TOKEN');

if(_app_token){
    API.defaults.headers.common['Authorization'] = `Bearer ${_app_token}`;
}

export const setupAPI = store => {
    API.interceptors.response.use(function (response) {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        return response;
    }, function (error) {
        let errorResponse = error.response;
        if(errorResponse.status === UNAUTHORIZED) {
            store.dispatch(resetState());
            let snsType = formatAppSnsType(localStorage.getItem('sns_type') || '');
            window.nativeLogoutToken(snsType);
            removeAllStorage();
        }
        return Promise.reject(error);
    });
}
export default API;
